import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import TeacherCard from './TeacherCard';
import '../../../assets/css/teacherMaster.css';
import { useNavigate } from 'react-router-dom';
import { FilterMatchMode } from 'primereact/api';
import AddTeacherMasterDialog from './AddTeacherMaster';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import ResetPassword from '../../ResetPassword/ResetPassword';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const TeacherMaster = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const [securityUserID, setSecurityUserID] = useState("");
    const [sortOption, setSortOption] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [visible, setVisible] = useState(false);
    const [viewMode, setViewMode] = useState('card');
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Name: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Phone: { value: null, matchMode: FilterMatchMode.CONTAINS },
        Email: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [teachersList, setTeachersList] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [updatedPassword, setUpdatedPassword] = useState('');
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [accessList, setAccessList] = useState({});

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetTeachersList(loginData?._id);
        GetConfigurationData(loginData?._id);
    }, []);

    const GetConfigurationData = async (id) => {
        try {
            let data = {
                id: id,
            }
            await api.post(APIConstant.path.GetPasswordConfigurationDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    setAccessList(res?.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
        }
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onCancel = () => {
        setVisible(false);
        GetTeachersList(securityUserID);
    }

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetTeachersList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            Loader.show();
            await api.post(APIConstant.path.getTeacherDetailList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTeachersList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-0" onClick={() => {
                        navigate('/viewEdit-teacher-master', { state: { userId: rows?._id, isEdit: true } })
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id, e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                    {rows?.Phone && accessList?.IsTeacher &&
                        <Button icon="pi pi-key" className="e-sction-btn p-m-0 p-m-2" onClick={(e) => {
                            setIsPasswordReset(true);
                            setDeleteId(rows._id);
                        }} />}
                </div>
            </React.Fragment>
        );
    };

    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteTeacher()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleResetClose = () => {
        setIsPasswordReset(false)
    };

    const handleDelete = (id) => {
        setIsDeleteConfirmation(true);
        setDeleteId(id);
    };

    const handleResetPassword = (id) => {
        setIsPasswordReset(true);
        setDeleteId(id);
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Update"
                className="btn-text-action-primary"
                onClick={(e) => UpdateStatus()}
            />
        </div>
    );

    const renderResetFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleResetClose}
            />
            <Button
                label="Update"
                className="btn-text-action-primary"
                onClick={(e) => UpdatePassword()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const handlePasswordChange = (password) => {
        setUpdatedPassword(password);
    };

    const UpdateStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateTeacherStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher status updated successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetTeachersList(securityUserID);
                }
                handleCloseStatus();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleCloseStatus();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err); 
            catchResponse(err);
        }
    }

    const UpdatePassword = async () => {
        try {
            let data = {
                id: deleteId,
                Password: updatedPassword
            }
            await api.post(APIConstant.path.updatePassword, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher password updated successfully' });
                    setDeleteId('');
                    setUpdatedPassword('');
                    await GetTeachersList(securityUserID);
                }
                handleResetClose();
            }).catch(err => {
                Loader.hide();
                Toast.error({ message: err?.message });
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
         }
    }

    const DeleteTeacher = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteTeacher, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Teacher deleted successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetTeachersList(securityUserID);
                }
                handleClose();
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                handleClose();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) { console.log(err);
            catchResponse(err);
        }
    }

    return (
        <div className='wayment-owner-dashboard'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user-edit"></i>
                    <h2>Teacher Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Global Search" />
                        </span>
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                    <Button
                        icon={viewMode === 'card' ? 'pi pi-bars' : 'pi pi-th-large'}
                        className="e-h-btn p-ml-2"
                        onClick={() => setViewMode(viewMode === 'card' ? 'list' : 'card')}
                    />
                </div>
            </div>
            <div className={viewMode === 'card' ? 'teacher-grid' : 'teacher-list'}>
                {viewMode === 'card' ? (
                    teachersList.filter(x => x?.Name?.toLowerCase()?.includes(globalFilterValue.toLowerCase()) || x?.Email?.includes(globalFilterValue) || x?.Phone?.includes(globalFilterValue)).map(teacher => (
                        <TeacherCard key={teacher._id} teacher={teacher} handleDelete={handleDelete} toggleActiveStatus={toggleActiveStatus} handlePassword={handleResetPassword} AccessList={accessList} />
                    ))
                ) : (
                    <DataTable
                        value={teachersList}
                        paginator
                        rows={rows}
                        first={first}
                        filters={filters}
                        filterDisplay="menu"
                        globalFilterFields={['TeacherId', 'Name', 'Phone', 'Email', 'StudentListCount', 'TotalCapacity']}
                        responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{width: '20%'}} />
                        <Column
                            field="TeacherId"
                            header="Teacher Id"
                            style={{width: '20%'}}
                        />
                        <Column
                            field="Name"
                            header="Name"
                            style={{width: '20%'}}
                        />
                        <Column
                            field="Phone"
                            header="Phone"
                            style={{width: '20%'}}
                        />
                        <Column
                            field="Email"
                            header="Email"
                            style={{width: '20%'}}
                        />
                        <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: '100%'}}/>
                    </DataTable>
                )}
            </div>
            <Dialog
                header="Add Teacher Master"
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: '60vw' }}
            >
                <AddTeacherMasterDialog onCancel={onCancel} />

            </Dialog>
            <Dialog
                visible={isPasswordReset}
                onHide={handleResetClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Reset Password</span>
                    </div>
                }
                footer={renderResetFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <ResetPassword onPasswordChange={handlePasswordChange} />
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
}

export default TeacherMaster;
